import {
  Component,
  OnInit,
  Input,
  Inject,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { VolvoApiService } from "../../../../services/volvo-api.service";
import { FormControlService } from "../../../../services/form-control.service";
import { FormFieldDropdown } from "../../../../models/form-field-dropdown";
import { HotelPageConfiguration } from "../../../../models/hotel-page-configuration";
import { FormFieldTextBox } from "../../../../models/form-field-textbox";

@Component({
  selector: "app-basic-registration",
  templateUrl: "./basic-registration.component.html",
  styleUrls: ["./basic-registration.component.scss"],
})
export class BasicRegistrationComponent implements OnInit {
  @Input() Guid: string;
  @Input() localStrings: Array<any>;
  @Input() AdditionalFieldsFormID: number;
  @Input() hotelPageConfig: HotelPageConfiguration;
  @Input() promotionAlias: string;
  @Input() isHotelPromotion: boolean;

  regForm: FormGroup;
  offerFormRowFields = [];
  errorMessages: Array<any>;
  public formSubmitAttempt: boolean;
  public termsExpanded: boolean = true;
  urlBase: string;
  submitSuccess = false;
  private partnerDropdown: FormFieldDropdown;
  private stateDropdown: FormFieldDropdown;
  private zipCodeField: FormFieldTextBox;
  private emailField: FormFieldTextBox;
  private phoneField: FormFieldTextBox;
  private currentVehicleDropdown: FormFieldDropdown;
  private currentVehicleMakeField: FormFieldTextBox;
  private BasicFields: any;
  private driversLicenseNumberField: FormFieldTextBox;
  private issuanceStateDropdown: FormFieldDropdown;

  CountryID = 271;
  showPreferredDealers = false;
  loadingDealers = false;
  noDealersFound = false;
  nearbyDealers: any = [];
  nearbyDealersLimit = 3;

  constructor(
    private volvoApi: VolvoApiService,
    private _fs: FormControlService
  ) {}

  ngOnInit() {
    this.urlBase = `${this.isHotelPromotion ? "/hotel" : ""}/${
      this.promotionAlias
    }`;

    const ls = this.localStrings;

    // partner dropdown
    const partnerValidationText =
      this.hotelPageConfig.PartnerCodeSelectValidationText != ""
        ? this.hotelPageConfig.PartnerCodeSelectValidationText
        : ls["AV.Promotions.lb.validation.partnerCode"];
    this.partnerDropdown = this._fs.createDropDownField(
      "partnerCode",
      null,
      null,
      Validators.required,
      partnerValidationText,
      partnerValidationText
    );
    this.offerFormRowFields.push([this.partnerDropdown]);

    this.BasicFields = this._fs.getBasicInfoFields(ls);
    Array.prototype.push.apply(this.offerFormRowFields, this.BasicFields);

    // state and zip code
    this.stateDropdown = this._fs.createDropDownField(
      "state",
      "column medium-6 form-control-wrapper",
      null,
      Validators.required,
      ls["AV.Promotions.lb.stateID"],
      ls["AV.Promotions.lb.stateID"]
    );
    this.zipCodeField = this._fs.createTextBox(
      "zipcode",
      ls["AV.Promotions.lb.zipcode"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.zipcode"],
      ls["AV.Promotions.lb.validation.zipcode.invalid"],
      [
        Validators.required,
        this._fs.patternValidator(
          /(^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]( )?\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]\d$)|(^\d{5}(-\d{4})?$)/
        ),
      ]
    );
    this.offerFormRowFields.push([this.stateDropdown, this.zipCodeField]);

    // email and phone number
    this.emailField = this._fs.createTextBox(
      "email",
      ls["AV.Promotions.lb.emailAddress"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.fromAddress"],
      ls["AV.Promotions.lb.validation.emailAddress.invalid"],
      [Validators.required, Validators.email]
    );
    this.phoneField = this._fs.createTextBox(
      "phone",
      ls["AV.Promotions.lb.phoneNumber"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.phoneNumber"],
      ls["AV.Promotions.lb.validation.phoneNumber.invalid"],
      [
        Validators.required,
        this._fs.patternValidator(
          /^(1[-. ]?)?(\([2-9]\d{2}\)|[2-9]\d{2})[-. ]?[2-9]\d{2}[-. ]?\d{4}(([xX]|ext|EXT)?\d{1,5})?$/
        ),
      ]
    );
    this.offerFormRowFields.push([this.emailField, this.phoneField]);

    // Current Vehicle
    this.currentVehicleDropdown = this._fs.createDropDownField(
      "currentVehicle",
      "column medium-6 form-control-wrapper",
      null,
      Validators,
      ls["AV.HotelPromotion.lb.currentvehicle"],
      ls["AV.HotelPromotion.lb.currentvehicle"]
    );

    this.currentVehicleMakeField = this._fs.createTextBox(
      "currentVehicleMake",
      ls["AV.HotelPromotion.lb.currentVehicleMake"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.HotelPromotion.lb.validation.currentVehicleMake"],
      ls["AV.HotelPromotion.lb.validation.currentVehicleMake.invalid"],
      null
    );
    // remove the vehicle field rows
    // that are only applicable to hotel promotions
    if (this.hotelPageConfig.Format !== "event") {
      this.offerFormRowFields.push([
        this.currentVehicleDropdown,
        this.currentVehicleMakeField,
      ]);
    }

    // Drivers lisence number and issuance state
    this.driversLicenseNumberField = this._fs.createTextBox(
      "driversLicenseNumber",
      ls["AV.Promotions.lb.driversLicenseNumber"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.fromDriversLicenseNumber"],
      null,
      [Validators.required]
    );
    this.issuanceStateDropdown = this._fs.createDropDownField(
      "issuanceState",
      "column medium-6 form-control-wrapper",
      null,
      Validators.required,
      ls["AV.Promotions.lb.issuanceState"],
      ls["AV.Promotions.lb.issuanceState"]
    );
    // remove the vehicle field rows
    // that are only applicable to hotel promotions
    if (this.hotelPageConfig.Format !== "event") {
      this.offerFormRowFields.push([
        this.driversLicenseNumberField,
        this.issuanceStateDropdown,
      ]);
    }

    if (this.hotelPageConfig.PromotionHidePrefContact == false) {
      // preferred method
      const methodOptions = [
        {
          label: ls["AV.Promotions.lb.contactMethodPhone"],
          value: "phone",
          checked: false,
        },
        {
          label: ls["AV.Promotions.lb.contactMethodEmail"],
          value: "email",
          checked: false,
        },
        // {
        //   label: ls["AV.Promotions.lb.contactMethodSMS"],
        //   value: "sms",
        //   checked: false,
        // },
        {
          label: ls["AV.Promotions.lb.contactMethodDoNotContact"],
          value: "doNotContact",
          checked: false,
        },
      ];
      const preferredMethodField = this._fs.createRadioField(
        "preferredContactMethod",
        ls["AV.Promotions.lb.contactMethod"],
        "",
        null,
        methodOptions,
        Validators.required,
        ls["AV.Promotions.lb.contactMethod.required"]
      );
      this.offerFormRowFields.push([preferredMethodField]);
    }

    this.createForm();

    // load states dropdown list
    const states = this.volvoApi.getStates(this.hotelPageConfig.CountryID);
    states.subscribe((r) => {
      this.stateDropdown.options = this._fs.createOptionsObj(
        r,
        "Id",
        ls["AV.Promotions.lb.stateID"]
      );
      this.issuanceStateDropdown.options = this._fs.createOptionsObj(
        r,
        "Id",
        ls["AV.Promotions.lb.issuanceState"]
      );
    });

    // load current vehicle dropdown list
    const currentVehicle = this.volvoApi.getCurrentVehicle();
    currentVehicle.subscribe((r) => {
      this.currentVehicleDropdown.options = this._fs.createOptionsObj(
        r,
        "ID",
        ls["AV.HotelPromotion.lb.currentvehicle"]
      );
      Array.prototype.push.apply(
        this.currentVehicleDropdown.options,
        this._fs.createOptionsObj(
          [
            { Name: ls["AV.HotelPromotion.lb.Other"], ID: "-1" },
            { Name: ls["AV.HotelPromotion.lb.NoVehicle"], ID: "NoVehicle" },
          ],
          "ID",
          ""
        )
      );
    });

    // load partners dropdown list
    let partners;
    if (this.hotelPageConfig.Format === "event") {
      partners = this.volvoApi.getAvailablePartners(this.Guid);
    } else {
      partners = this.volvoApi.getAvailableHotelPartners(this.Guid);
    }

    partners.subscribe((r) => {
      const selectLabel = this.hotelPageConfig.PartnerCodeSelectText
        ? this.hotelPageConfig.PartnerCodeSelectText
        : ls["AV.Promotions.lb.partnerSelectText"];

      this.partnerDropdown.options = this._fs.createOptionsObj(
        r,
        "Code",
        selectLabel
      );
      // select and hide dropdown if there is only one partner
      if (r.length == 1) {
        this.partnerDropdown.options[1].selected = true;
        this.regForm.controls["partnerCode"].setValue(
          this.partnerDropdown.options[1].key
        );
        this.partnerDropdown.cssClasses += " hide";
      }
    });
  }

  get agreeterm() {
    return this.regForm.get("agreeterm");
  }

  get agreeterm_optin() {
    return this.regForm.get("agreeterm_optin");
  }

  get preferredDealerID() {
    return this.regForm.get("preferredDealerID");
  }

  createForm() {
    this.regForm = this._fs.toFormGroup(this.offerFormRowFields);

    // as per #25909481, we are keeping the non-mandatory optin and updating its text.
    // (the second mandatory optin text will be moved to the first)

    this.regForm.get("optin");
    this.regForm.addControl(
      "optin",
      new FormControl("", Validators.nullValidator)
    );
    this.regForm.controls["optin"].setValue(false);

    if (!this.isHotelPromotion) {
      this.regForm.addControl(
        "agreeterm_optin",
        new FormControl("", Validators.requiredTrue)
      );
    }

    this.regForm.addControl(
      "agreeterm",
      new FormControl("", Validators.requiredTrue)
    );

    this.regForm.addControl(
      "preferredDealerID",
      new FormControl("", Validators.required)
    );

    this.checkFormValues();
  }

  checkFormValues() {
    // if we have preferred contacts,
    // we need to wait and check
    if (this.hotelPageConfig.PromotionHidePrefContact == false) {
      this.regForm.get("zipcode").valueChanges.subscribe((val) => {
        this.checkFieldsForNearestDealer();
      });

      this.regForm
        .get("preferredContactMethod")
        .valueChanges.subscribe((val) => {
          if (
            val === "doNotContact" ||
            (this.nearbyDealers.length === 0 &&
              !this.noDealersFound &&
              !this.loadingDealers)
          ) {
            this.checkFieldsForNearestDealer();
          }
        });
    } else {
      this.regForm.get("preferredDealerID").setValue(0);
    }
  }

  checkFieldsForNearestDealer() {
    const _inputContactMethod = this.regForm.get("preferredContactMethod");
    const addressZipValid = this.regForm.get("zipcode").valid;
    const contactMethodSelected =
      _inputContactMethod.value !== "" &&
      _inputContactMethod.value !== "doNotContact";

    this.nearbyDealers = [];
    this.showPreferredDealers = false;
    this.noDealersFound = false;
    this.regForm.get("preferredDealerID").setValue("");

    if (addressZipValid && contactMethodSelected) {
      this.nearestDealerOptions();
    } else {
      if (_inputContactMethod.value === "doNotContact") {
        this.regForm.get("preferredDealerID").setValue(0);
      }
    }
  }

  nearestDealerOptions() {
    // load states dropdown list
    this.showPreferredDealers = true;
    this.loadingDealers = true;

    let dealers = this.volvoApi.getNearestDealers(
      this.regForm.get("address").value,
      this.regForm.get("city").value,
      this.regForm.get("zipcode").value,
      this.CountryID
    );
    dealers.subscribe((r) => {
      if (r.length === 0) {
        this.noDealersFound = true;
      } else {
        this.nearbyDealers = r;
      }

      this.loadingDealers = false;
    });
  }

  selectNearbyDealer(e) {
    this.regForm.get("preferredDealerID").setValue(e.target.value);
  }

  showMoreRetailLocations(e) {
    this.nearbyDealersLimit = 6;
  }

  isFieldValid(field: string) {
    return (
      (!this.regForm.get(field).valid &&
        (this.regForm.get(field).touched || this.regForm.get(field).dirty)) ||
      (this.regForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  clickSubmit() {
    if (this._fs.validateForm(this.regForm)) {
      this.onSubmit();
    }
  }

  clickTermsExpand() {
    this.termsExpanded = !this.termsExpanded;
  }

  onSubmit() {
    if (this.regForm.valid) {
      this.formSubmitAttempt = true;
      const formData = this.regForm.value;
      formData.promotionGuid = this.Guid;

      formData.culture = this.volvoApi.getCultureCode();

      if (formData.preferredContactMethod == undefined) {
        formData.preferredContactMethod = "";
      }

      formData.extraFields = [];

      if (this.hotelPageConfig.Format === "event") {
        formData.externalID = "";
        formData.referenceID = "";

        this.volvoApi.createPin(formData).subscribe((r) => {
          // console.log(r);
          if (r.Success) {
            // console.log('success');
            this.formSubmitAttempt = false;
            this.submitSuccess = true;
            setTimeout(() => {
              this.resetForm();
            }, 15000);
          } else {
            this.errorMessages = r.ErrorMessages;
            console.error("error creating pin", this.errorMessages);
            window.alert(`There was an error creating a PIN\n${this.errorMessages && this.errorMessages.length > 0 ? this.errorMessages.map(item => item.Value).join('\n') : ''}`);
          }
        });
      } else {
        // set these fields to empty b/c they are
        // not used on Affinity HOTEL PTOs
        formData.DriveStartDate = "";
        formData.DriveEndDate = "";
        formData.DriveEndTime = "";

        this.volvoApi.createHotelPin(formData).subscribe((r) => {
          // console.log(r);
          if (r.Success) {
            // console.log('success');
            this.formSubmitAttempt = false;
            this.submitSuccess = true;
            setTimeout(() => {
              this.resetForm();
            }, 15000);
          } else {
            this.errorMessages = r.ErrorMessages;
            console.error("error creating pin", this.errorMessages);
            window.alert(`There was an error creating a PIN\n${this.errorMessages && this.errorMessages.length > 0 ? this.errorMessages.map(item => item.Value).join('\n') : ''}`);
          }
        });
      }
    }
  }

  resetForm() {
    this.submitSuccess = false;
    this.regForm.reset();
    if (this.partnerDropdown.options.length == 2) {
      this.partnerDropdown.options[1].selected = true;
      this.regForm.controls["partnerCode"].setValue(
        this.partnerDropdown.options[1].key
      );
    } else {
      this.partnerDropdown.options[0].selected = true;
      this.regForm.controls["partnerCode"].setValue(
        this.partnerDropdown.options[0].key
      );
    }

    this.stateDropdown.options[0].selected = true;
    this.regForm.controls["state"].setValue(this.stateDropdown.options[0].key);

    this.currentVehicleDropdown.options[0].selected = true;
    this.regForm.controls["currentvehicle"].setValue(
      this.currentVehicleDropdown.options[0].key
    );

    this.regForm.updateValueAndValidity();
  }
}
